import { useMutation } from 'react-query'
import { api } from '../../../api'

const removeExpert = (id: number) => {
  return api.delete(`/experts/${id}`)
}

export const useExpertRemoveMutation = () => {
  return useMutation('remove-expert', {
    mutationFn: (id: number) => {
      return removeExpert(id)
    },
  })
}
